import { FC, useContext } from 'react';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useSelector } from 'src/hooks/useSelector';

import CommentsButton from 'src/components/ResumeCard/Actions/Comments/Button';

const CommentsButtonWrapper: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    const userId = useContext(ResumeCardActionsContext).resume._attributes.user;
    const comments = useSelector((state) => state.commentsByUserId?.[userId]);

    return <CommentsButton comments={comments} isMobile={isMobile} />;
};

export default CommentsButtonWrapper;
